import { Film } from "lucide-react";

const EditMiddlePanel = ({
  slides,
  activeSlide,
  slidesAnimationData,
  currentSlideBackground,
  currentSlideBackgroundColor,
}) => {
  return (
    <div className="col-span-6 bg-white rounded-2xl shadow p-6 flex items-center justify-center">
      <div className="w-full h-[30rem] border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center bg-gray-50 overflow-hidden relative">
        {activeSlide !== null &&
          slides[activeSlide] &&
          !slides[activeSlide].is_active && (
            <div className="absolute top-4 left-4 bg-gray-500 text-white text-[11px] px-2 py-1 rounded-md font-bold z-30 flex items-center gap-1.5 shadow-md">
              <div className="w-1.5 h-1.5 bg-gray-300 rounded-full animate-pulse"></div>
              HIDDEN
            </div>
          )}

        <div
          className={`w-full h-full flex items-center justify-center ${
            activeSlide !== null &&
            slides[activeSlide] &&
            !slides[activeSlide].is_active
              ? "opacity-40 grayscale-[0.7]"
              : ""
          }`}
        >
          {activeSlide !== null && slides.length > 0 ? (
            <>
              {/* IMAGE SLIDE */}
              {slides[activeSlide].type === "image" && (
                <img
                  src={slides[activeSlide].image?.image_url}
                  alt={slides[activeSlide].title}
                  className="object-contain w-full h-full"
                />
              )}

              {/* BLANK SLIDE */}
              {slides[activeSlide].type === "blank" && (
                <div
                  className="w-full h-full flex flex-col items-center justify-center gap-2"
                  style={{
                    backgroundColor:
                      slidesAnimationData?.[activeSlide]
                        ?.canvasBackgroundColor || "#1a1a2e",
                  }}
                >
                  <Film className="w-10 h-10 text-white/30" />
                  <p className="text-white/40 text-sm font-medium">
                    Animated Slide
                  </p>
                  <p className="text-white/25 text-xs">
                    Open the Animation Editor to add elements
                  </p>
                </div>
              )}

              {/* POLL / MULTIPLE */}
              {(slides[activeSlide].question?.question_type === "poll" ||
                slides[activeSlide].question?.question_type === "multiple") && (
                <div
                  className="p-6 w-full h-full"
                  style={{
                    backgroundColor: currentSlideBackgroundColor,
                    ...(currentSlideBackground
                      ? {
                          backgroundImage: `url("${currentSlideBackground}")`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                        }
                      : {}),
                  }}
                >
                  <p className="font-bold text-xl mb-4 text-black">
                    {slides[activeSlide].title}
                  </p>

                  <h2 className="text-xl font-bold mb-4">
                    {slides[activeSlide].question.question_text}
                  </h2>

                  <ul>
                    {slides[activeSlide]?.question?.choices?.map(
                      (choice, i) => (
                        <li
                          key={i}
                          className="p-2 border rounded-md flex items-center space-x-2 my-3 bg-white/80"
                        >
                          <input
                            readOnly
                            type={
                              slides[activeSlide].question.question_type ===
                              "poll"
                                ? "radio"
                                : "checkbox"
                            }
                            className="h-4 w-4 text-lightPurple"
                          />

                          <label className="text-gray-700">
                            {typeof choice === "object"
                              ? choice.choice_text
                              : choice}
                          </label>
                        </li>
                      ),
                    )}
                  </ul>
                </div>
              )}

              {/* TEXT QUESTION */}
              {slides[activeSlide].question?.question_type === "text" && (
                <div
                  className="p-6 w-full h-full"
                  style={{
                    backgroundColor: currentSlideBackgroundColor,
                    ...(currentSlideBackground
                      ? {
                          backgroundImage: `url("${currentSlideBackground}")`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                        }
                      : {}),
                  }}
                >
                  <p className="font-bold text-xl mb-4 text-black">
                    {slides[activeSlide].title}
                  </p>

                  <h2 className="text-xl font-bold mb-4">
                    {slides[activeSlide].question.question_text}
                  </h2>

                  <textarea
                    readOnly
                    placeholder="Answer..."
                    className="w-full border rounded p-2 min-h-[100px]"
                  />
                </div>
              )}
            </>
          ) : (
            <span className="text-gray-500">Slide Preview</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditMiddlePanel;
